import { useAppContext } from "Appcontext";
import axios from "axios";
import { FileUpload } from "primereact/fileupload";
import { useState } from "react";

export default function AdvanceDemo() {
  const { selectBranch } = useAppContext();
  const [helperText, setHelperText] = useState("");
  return (
    <div className="card">
      <p>Tải lên file Excel đã xuất hàng ngày</p>{" "}
      <FileUpload
        name="file"
        // url={process.env.REACT_APP_API + `/api/upload-excel-day`}
        accept=".xls,.xlsx"
        maxFileSize={1000000}
        customUpload
        uploadHandler={async (e) => {
          setHelperText("");
          try {
            const formData = new FormData();
            formData.append("file", e.files[0]);
            formData.append("branch", selectBranch);
            const res = await axios.post(
              process.env.REACT_APP_API + `/api/upload-excel-day`,
              formData
            );
            setHelperText("Tải lên thành công");
          } catch (error) {
            setHelperText("Tải lên thất bại");
          }
          return;
        }}
        multiple={false}
        emptyTemplate={
          <p className="m-0 h-40">Drag and drop files to here to upload.</p>
        }
      />
      {helperText ? (
        <div className="border p-4 bg-slate-100 mt-2">{helperText}</div>
      ) : null}
    </div>
  );
}
